// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2919": "e7cc14d5","3703": "7c6b009d","494": "40775784","7794": "b8b255dc","9730": "76599b25",}[chunkId] + ".css"
}